import React, { createContext, useContext } from 'react'
import { useQuery } from '@apollo/client'
import { mixpanelClient } from '../utils/MixpanelTracker'
import Loading from '../components/Loading'
import { LOAD_ME_QUERY } from '../graphql/user'
import { AuthContext } from '@dexter-experts/auth-react'

const UserContext = createContext({ user: null })
export const UserProvider = ({ children }) => {
  const { token } = useContext(AuthContext)

  const { loading, data } = useQuery(LOAD_ME_QUERY, {
    skip: !token,
    // Without the expert there is nothing to render, so the alert has nowhere
    // to return to and dismissing it has to reload.
    context: { fatalError: true },
  })

  if (loading) return <Loading />
  if (!data) return <div />

  mixpanelClient.identify(data.me.fullName || data.me.email)

  return (
    <UserContext.Provider value={{ user: data.me }}>
      {children}
    </UserContext.Provider>
  )
}

export default UserContext
